// ページ内の位置付き URL の送り先を変える: <div data-mp-hash-forward="/program/basic/">
// 以前 /program/ にあった MPベーシックプログラムは /program/basic/ に移った。
// /program/#payment-methods のような URL（LINE・メール・広告に残っているもの）は # 以降がサーバーに届かず 301 で転送できないので、
// このページに該当する位置が無いときだけ、同じ # を付けて送り先へ移る。

export function setupHashForward() {
  const root = document.querySelector('[data-mp-hash-forward]');
  const id = decodeURIComponent(window.location.hash.slice(1));
  if (!root || !id || document.getElementById(id)) return;
  window.location.replace(root.dataset.mpHashForward + window.location.hash);
}
